import { Link } from 'react-router-dom';
import { CATEGORIES, getCategoryMovies } from '@/data/catalog';

export default function CategoryEntries() {
  return (
    <section className="mx-auto w-full max-w-[1440px] px-4 md:px-8" aria-label="影视分类快捷入口">
      <div className="-mt-8 grid grid-cols-3 gap-2.5 md:-mt-10 md:grid-cols-6 md:gap-3">
        {CATEGORIES.map((category) => (
          <Link
            key={category.key}
            to={`/category/${category.key}`}
            className="group flex cursor-pointer flex-col items-center gap-2 rounded-lg border border-background-200 bg-background-50 px-2 py-4 transition-colors hover:border-primary-300 md:flex-row md:items-center md:gap-3 md:px-4 md:py-4"
          >
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-primary-50 text-primary-600 transition-colors group-hover:bg-accent-500 group-hover:text-background-50">
              <i className={`${category.icon} text-xl`} />
            </span>
            <span className="min-w-0 text-center md:text-left">
              <span className="block truncate text-sm font-medium text-foreground-950">{category.title}</span>
              <span className="mt-0.5 hidden text-[11px] text-foreground-400 sm:block">
                {getCategoryMovies(category.key).length} 部作品
              </span>
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}